import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FileText, Settings, ArrowRight } from 'lucide-react';
import AuthRequired from '@/components/auth/AuthRequired';
import AdminLayout from '@/components/admin/AdminLayout';

const AdminDashboard = () => {
  const navigate = useNavigate();

  return (
    <AuthRequired>
      <AdminLayout>
        <div className="container mx-auto py-8">
          <h1 className="text-3xl font-bold mb-8">Dashboard</h1>

          <div className="grid md:grid-cols-2 gap-6">
            <Card className="border-2 border-gray-200 hover:border-blue-200 transition-all shadow-sm hover:shadow-md">
              <CardHeader className="pb-2 bg-gray-50 border-b border-gray-200">
                <CardTitle className="flex items-center text-xl text-blue-700">
                  <FileText size={20} className="mr-2" />
                  Blog
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-4">
                <p className="text-gray-600 mb-4">
                  Gerencie os posts do seu blog diretamente pelo painel administrativo.
                </p>
              </CardContent>
              <CardFooter className="bg-gray-50 border-t border-gray-200 pt-4 pb-4">
                <Button 
                  onClick={() => navigate('/admin/blog')}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white admin-action-button"
                >
                  Gerenciar Blog Posts
                  <ArrowRight size={16} className="ml-2" />
                </Button>
              </CardFooter>
            </Card>

            <Card className="border-2 border-gray-200 hover:border-blue-200 transition-all shadow-sm hover:shadow-md">
              <CardHeader className="pb-2 bg-gray-50 border-b border-gray-200">
                <CardTitle className="flex items-center text-xl text-blue-700">
                  <Settings size={20} className="mr-2" />
                  Configurações
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-4">
                <p className="text-gray-600 mb-4">
                  Acesse configurações e personalizações do site.
                </p>
              </CardContent>
              <CardFooter className="bg-gray-50 border-t border-gray-200 pt-4 pb-4">
                <Button 
                  variant="outline" 
                  disabled
                  className="w-full border-gray-300 text-gray-500"
                >
                  Configurações (em breve)
                  <ArrowRight size={16} className="ml-2" />
                </Button>
              </CardFooter>
            </Card>
          </div>
        </div>
      </AdminLayout>
    </AuthRequired>
  );
};

export default AdminDashboard;
